module.exports = __webpack_public_path__ + "static/media/phila_set.0d942aed.jpeg";